import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {Dropdown} from "primereact/dropdown";
import {InputMask} from "primereact/inputmask";
import moment from "moment";
import {Calendar} from "primereact/calendar";

const DocsFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    document_category: 1
  });
  const [templates, setTemplates] = useState([]);
  const [wildcards, setWildcards] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    apiCall('post', '/api/v2/document', data)
      .then(response => {
        window.App.toastShow('success', 'Sikeres mentés!');
        window.App.setState({rerenderDocsList: Math.random()})
        if (props.goback === true) {
          history.push(props.backlink);
        } else {
          history.push('/docs/update/' + response.data.data.id);
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/document-template')
      .then(response => {
        let _templates = []
        response.data.data.items.map((item, index) => {
          _templates.push({
            id: item.id,
            name: t(item.related_entity) + ' / ' + item.name,
          })
        })
        setTemplates(_templates)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().calendarCategoryId) || (entity === 'docs' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/document/' + (window.App.urlVars().docsId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    if (entity !== 'docs' && id) {
      setFormData({
        ...formData,
        related_entity_id: id
      })
    }
  }, [])

  return (
    <div className={"docs-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="document_template" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="document_template"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDocumentTemplate')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(templates, "name")}
                               id={"document_template"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noTemplateYet')}
                               onChange={(e) => {
                                 let _template = templates.find(item => item.id === e.value)
                                 setFormData({
                                   ...formData,
                                   document_template: e.value,
                                   name: _template?.name,
                                 })
                                 apiCall('get', '/api/v2/document-template/variable-requirements/' + e.value)
                                   .then(response => {
                                     let _wildcards = []
                                     Object.entries(response.data.data).forEach((entry, key) => {
                                       let _options = []
                                       if(entry[1].form_type === 'select') {
                                         apiCall('get', entry[1].form_source
                                          ?.replace('{employee_id}', (window.App.urlVars().employeeId ?? id))
                                          ?.replace('{candidate_id}', (window.App.urlVars().candidateId ?? id)))
                                           .then(response => {
                                             response.data.data.items.map((item, index) => {
                                               _options.push({
                                                 id: item.id,
                                                 original: item,
                                                 label: item.employment_type.name,
                                               })
                                             })
                                           })
                                       }
                                       _wildcards.push({
                                         label: entry[0],
                                         original: entry[1],
                                         options: _options
                                       })
                                     })
                                     setWildcards(_wildcards)
                                   })
                               }}
                               value={Number(window.App.urlVars().templateId) || formData.document_template?.id || formData.document_template}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {/*<div className={"p-col-12 p-lg-3"}>*/}
            {/*  <Field name="related_entity" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="related_entity"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRelatedEntity')}</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*         <Dropdown options={window.App.sortDropdownOptions(entities, "key")}*/}
            {/*                   id={"related_entity"}*/}
            {/*                   optionValue={"value"}*/}
            {/*                   optionLabel={"key"}*/}
            {/*                   emptyMessage={t('noEntityYet')}*/}
            {/*                   onChange={(e) => {*/}
            {/*                     setFormData({*/}
            {/*                       ...formData,*/}
            {/*                       related_entity: e.value*/}
            {/*                     })*/}
            {/*                   }}*/}
            {/*                   value={Number(window.App.urlVars().relatedEntityId) || formData.related_entity?.id || formData.related_entity}*/}
            {/*         />*/}
            {/*        </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            {/*<div className={"p-col-12 p-lg-4"}>*/}
            {/*  <Field name="document_category" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="document_category"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCategory')}</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*         <Dropdown options={window.App.sortDropdownOptions(categories, "name")}*/}
            {/*                   id={"document_category"}*/}
            {/*                   optionValue={"id"}*/}
            {/*                   optionLabel={"name"}*/}
            {/*                   emptyMessage={t('noCategoryYet')}*/}
            {/*                   onChange={(e) => {*/}
            {/*                     setFormData({*/}
            {/*                       ...formData,*/}
            {/*                       document_category: e.value*/}
            {/*                     })*/}
            {/*                   }}*/}
            {/*                   value={Number(window.App.urlVars().categoryId) || formData.document_category?.id || formData.document_category}*/}
            {/*         />*/}
            {/*        </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
          </div>
          {wildcards && wildcards[0] &&
            <div className={"p-grid p-mt-1"}>
              {wildcards.map((card, index) => {
                if (card.original.form_type === 'select') {
                  return (
                    <div className={"p-col-12"} key={index}>
                      <div className="p-field p-fluid">
                        <label htmlFor="document_template">{card?.original?.label || card.label}</label>
                        <span className="p-d-block">
                         <Dropdown options={window.App.sortDropdownOptions(card.options, "label")}
                                                 id={"related_entity"}
                                                 optionValue={"id"}
                                                 optionLabel={"label"}
                                                 emptyMessage={t('noEntityYet')}
                                                 onChange={(e) => {
                                                   setFormData({
                                                     ...formData,
                                                     [card?.original?.form_name]: e.value
                                                   })
                                                 }}
                                                 value={formData[card?.original?.form_name]}
                                       />

                      </span>
                      </div>
                    </div>
                  )
                }
                if (card.original.form_type === 'date') {
                  return (
                    <div className={"p-col-12 p-lg-12"} key={index}>
                      <div className="p-field p-fluid">
                        <label htmlFor="document_template">{card?.original?.label || card.label}</label>
                        <span className="p-d-block">
                          <div className="p-inputgroup calendar-icon-only">
                              <InputMask id={card?.original?.form_name}
                                         mask={"9999-99-99"}
                                         placeholder={t('datePlaceholder')}
                                         value={moment.utc(formData[card?.original?.form_name] || '').local().format('YYYY-MM-DD')}
                                         onChange={(e) => {
                                           if (e.value.indexOf("_") === -1) {
                                             if (e.value === '') {
                                               e.value = null
                                             }
                                             setFormData({
                                               ...formData,
                                               [card?.original?.form_name]: moment.utc(e.value).local().format('YYYY-MM-DD')
                                               //[card?.original?.form_name]: new Date(e.value)
                                             })
                                           }
                                         }}
                              />
                              <Calendar value={formData[card?.original?.form_name]}
                                        locale="hu"
                                        dateFormat={'yy-mm-dd'}
                                        showIcon
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            [card?.original?.form_name]: moment.utc(e.value).local().format('YYYY-MM-DD')
                                          })
                                        }}/>
                          </div>
                        </span>
                      </div>
                    </div>
                  )
                }
                if (card.original.form_type === 'text') {
                  return (
                    <div className={"p-col-12 p-lg-12"} key={index}>
                      <div className="p-field p-fluid">
                        <label htmlFor="document_template">{card?.original?.label || card.label}</label>
                        <span className="p-d-block">
                        <InputText id={card?.original?.form_name}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       [card?.original?.form_name]: e.target.value
                                     })
                                   }}
                                   value={formData[card?.original?.form_name]}
                                   />
                        </span>
                      </div>
                    </div>
                  )
                }
              })}
            </div>
          }
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'docs' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )
      }/>
    </div>
  )
}
export default withTranslation('common')(DocsFormComponent);
